import { render, staticRenderFns } from "./PixelModal.vue?vue&type=template&id=6eba629a&scoped=true&"
import script from "./PixelModal.vue?vue&type=script&lang=js&"
export * from "./PixelModal.vue?vue&type=script&lang=js&"
import style0 from "./PixelModal.vue?vue&type=style&index=0&id=6eba629a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eba629a",
  null
  
)

export default component.exports